var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"flex flex-col w-full pb-60 md:pb-0"},[(!_vm.currentValuation)?_c('ToolsHeader',{attrs:{"tool-tabs":_vm.toolTabs}}):_vm._e(),_c(_vm.currentComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }